export const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl'] as const;

export type Breakpoints = (typeof BREAKPOINTS)[number];

export type BreakpointsWithDefault = (typeof BREAKPOINTS)[number] | '';

const breakpointCache = new Map<BreakpointsWithDefault, number>();

export function isBreakpointKey(key: string): key is Breakpoints {
  return (BREAKPOINTS as readonly string[]).includes(key);
}

export function getBreakpoint(breakpoint: BreakpointsWithDefault): number {
  // Empty string represents base/mobile (no min-width)
  if (breakpoint === '') {
    return 0;
  }

  if (breakpointCache.has(breakpoint)) {
    return breakpointCache.get(breakpoint)!;
  }

  const value = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(`--ref-breakpoint-${breakpoint}`),
    10,
  );

  if (isNaN(value)) {
    console.warn(
      `Breakpoint --ref-breakpoint-${breakpoint} not found in CSS. Make sure custom properties are defined.`,
    );

    return 0;
  }

  breakpointCache.set(breakpoint, value);

  return value;
}

export function clearBreakpointCache(): void {
  breakpointCache.clear();
}
